export const ACCOUNTING_CUSTOMERS_FILTERS = {
    filters: [
        {
            name: 'Storage',
            label: 'In Storage',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'filter-yes-no-all',
        },
        {
            name: 'CommissionRangeMotherAgency',
            label: 'Default M.A. Commission',
            area: 'billing',
            areaIndex: 4,
            defaultval: [0, 100],
            commontype: null,
            type: 'percentage-range',
        },
        {
            name: 'CommissionRangeAgencyFee',
            label: 'Default Agency Fee',
            area: 'billing',
            areaIndex: 4,
            defaultval: [0, 100],
            commontype: null,
            type: 'percentage-range',
        },
        {
            name: 'InvoiceType',
            label: 'Invoice Type',
            area: 'billing',
            areaIndex: 4,
            defaultval: null,
            commontype: null,
            type: 'invoice-type-selector',
        },
        {
            name: 'HasVat',
            label: 'Has VAT Number',
            area: 'billing',
            areaIndex: 4,
            defaultval: null,
            commontype: null,
            type: 'filter-yes-no-all',
        },
        {
            name: 'Statement',
            label: 'Statement',
            area: 'billing',
            areaIndex: 4,
            defaultval: [null, null, null, null],
            commontype: null,
            type: 'statement-filter',
        },
    ],
};
